export const ICONVERSION = '1.4'

export enum Icons {

    MISSING = 'wb-icon-212__error--default',

    ARROW_RIGHT = 'wb-icon-4__arrow--default',
    PRINT = 'wb-icon-39__print--default',
    ADD = 'wb-icon-20__plus--default',
    SAVE = 'wb-icon-148__save--default',
    CANCEL = 'wb-icon-12__close--default',
    LIST = 'wb-icon-420__switch-list--default',
    EXPORT = 'wb-icon-23__download--default',
    CONTINUE = 'wb-icon-517__message-send--default',
    BACK = 'wb-icon-169__back--default',
    DELETE = 'wb-icon-47__delete--default',
    ARCHIVE = 'wb-icon-92__archive--default',
    SEARCH = 'wb-icon-150__search--default',
    RESET = 'wb-icon-182__reload--default',
    CONFIRM = 'wb-icon-3__checkmark--default',
    COPY = 'COPY',
    EDIT = 'wb-icon-44__edit--default',
    CART = 'wb-icon-158__shopping--default',
    OVERVIEW = 'wb-icon-112__design--default',
    CHAT = 'wb-icon-104__chat--default',
    DOCUMENT = 'wb-icon-114__download-printed--default',
    DOWNLOAD = 'wb-icon-23__download--default',
    FEHLER = 'wb-icon-516__alert--default',
    ADD_USER = 'ADD_USER',
    AJAX_LOADER = 'wb-icon-428__buffer-loader--default',
    EYE = 'wb-icon-112__design--active',
    EYE_GREY = 'wb-icon-112__design--default',
    LOCK = 'wb-icon-513__lock-closed--default',
    WARNING = 'wb-icon-196__warning--default',
    UPLOAD = 'wb-icon-188-upload--default',
    TAG = 'wb-icon-48__bookmark--default',
    INFO_BOX = 'wb-icon-213__info--default',
    CLOSE = 'wb-icon-12__close--default',
    CALENDAR = 'wb-icon-94__calendar--default',
    ZOOM = 'wb-icon-424__zoom-in-2--default',
    ZOOM_THIN = 'wb-icon-369__zoomin2-xs--default',
    ZOOM_MAGNIFY = 'wb-icon-207__zoom--default',
    ARROW_UP = 'wb-icon-19__arrow-up--default',
    ARROW_DOWN = 'wb-icon-18__arrow-down--default',
    VIEW = 'wb-icon-150__search--default',
    REPLY = 'wb-icon-168__back--default',
    VERTRAG = 'VERTRAG',
    VERTRAG_ERROR = 'VERTRAEGE_CONTRACT_NORMAL_DISABLED',
    VERTRAG_LEAD = 'VERTRAEGE_CONTRACT_LEAD',
    VERTRAG_LEAD_ERROR = 'VERTRAEGE_CONTRACT_LEAD_DISABLED',
    RECOMMENDED = 'wb-icon-41__favorite--default',
    HAKEN = 'wb-icon-1__checkmark--default',
    MAIL = 'wb-icon-111__contact--default',
    VIDEO = 'wb-icon-164__video--default',
    IMAGE = 'wb-icon-130__img-gallery--default',
    MUSIC = 'wb-icon-146__music--default',
    SETTINGS = 'wb-icon-156__settings--default',
    CIRCLE = 'wb-icon-15__page-control--default',
    CIRCLE_EMPTY = 'wb-icon-77__hotspot--default',
    SHOPPINGCART = "wb-icon-158__shopping--default",
    FINANCE = "wb-icon-68__finance--default",

    PARTNER_DENIED = 'EVALUATION_STATE_DENIAL',
    PARTNER = 'LAW',
    PARTNER_STAR = 'PARTNER_STAR',
    PARTNER_GU = 'PARTNER_GU',
    PARTNER_GU_STAR = 'PARTNER_GU_STAR',
    PARTNER_GU_VS = 'PARTNER_GU_VS',
    SCALE = 'SCALE',
    MEDAL = 'PRAEMIERUNGS_ORDEN',
    DRAG_ARROWS = 'DRAG_ARROWS',
    STORNO = 'STORNO',
    LKW = 'LKW',
    LKW_BIG = 'LKW_BIG',
    TRANSPORTER = 'TRANSPORTER',
    TRANSPORTER_BIG = 'TRANSPORTER_BIG',
    EVOBUS = 'EVOBUS',
    EVOBUS_BIG = 'EVOBUS_BIG',
    UNIMOG = 'UNIMOG',
    UNIMOG_BIG = 'UNIMOG_BIG',
    ATTACHMENT = 'ATTACHMENT',
    FILE_PDF = 'PDF',
    FILE_WORD = 'WORD',
    FILE_EXCEL = 'EXCEL',
    FILE_IMAGE = 'IMAGE',
    FILE_PPT = 'POWERPOINT',
    FILE_ZIP = 'ZIP',
    FILE_TXT = 'TXT',
    FILE_UNKNOWN = 'UNKNOWN_FILE',
    ANMELDESTUFE_NEU = 'wb-icon-156__settings--default',
    ANMELDESTUFE_DEAKTIVIERT = 'wb-icon-513__lock-closed--default',
    ANMELDESTUFE_REGISTRIERT = 'wb-icon-1__checkmark--default',
    ANMELDESTUFE_ABGELEHNT = 'wb-icon-12__close--default',
    ANMELDETYP_ABH = 'ANMELDETYP_PARTNER',
    ANMELDETYP_PARTNER = 'ANMELDETYP_ABH',
    ANMELDETYP_SONSTIGE = 'ANMELDETYP_SONSTIGE',
    ANMELDETYP_ENDKUNDE = 'ANMELDETYP_ENDKUNDE',
    MONITORING_1_OK = 'MONITORING_1',
    MONITORING_1_WARNING = 'MONITORING_1_ROT',
    MONITORING_2_OK = 'MONITORING_2',
    MONITORING_2_WARNING = 'MONITORING_2_ROT',
    MONITORING_3_OK = 'MONITORING_3',
    MONITORING_3_WARNING = 'MONITORING_3_ROT',
    MONITORING_4_OK = 'MONITORING_4',
    MONITORING_4_WARNING = 'MONITORING_4_ROT',
    MONITORING_5_OK = 'MONITORING_5',
    MONITORING_5_WARNING = 'MONITORING_5_ROT',
    MONITORING_6_OK = 'MONITORING_6',
    MONITORING_6_WARNING = 'MONITORING_6_ROT',
    MONITORING_7_OK = 'MONITORING_7',
    MONITORING_7_WARNING = 'MONITORING_7_ROT',
    MONITORING_8_OK = 'MONITORING_8',
    MONITORING_8_WARNING = 'MONITORING_8_ROT',
    MONITORING_9_OK = 'MONITORING_9',
    MONITORING_9_WARNING = 'MONITORING_9_ROT',
    AUFBAU = 'FUELLUNG_AUFBAU',
    AN_UMBAU = 'FUELLUNG_AN_UMBAU',
    PRODUKTE = 'FUELLUNG_PRODUKTE',
    PRODUKTE_RECOMMENDED = 'FUELLUNG_VAN_PARTNER',
    USERS = 'FUELLUNG_KONTAKT',
    USERS_RECOMMENDED = 'FUELLUNG_BENUTZER',
    VIRUS_OK = 'VIRUS_GREEN',
    VIRUS_FOUND = 'VIRUS_RED',
    MAP = 'MAP',
    COMMENT_NEW = 'TEXT_BUBBLE_EMPTY',
    COMMENTS = 'TEXT_BUBBLE_FILLED',
    INQUIRY = 'ERG_MONITORING_REQUEST',
    PRODUKT_RECOMMENDED = 'ERG_MONITORING_APPROVAL',
    OK = 'ERG_MONITORING_OK',
    HAND = 'ERG_STORNIEREN',
    FINANCE_RECOMMENDED = 'ERG_ANGEBOTS_FREIGABE',
    CALENDAR_WARNING = 'GLT_DATE_INPUT_REQUIRED',
    CALENDAR_CHECK = 'GLT_DATE_CHANGE_CHECK',
    CALENDAR_TIME = 'GLT_DATE_DELAY_BIG',
    CALENDAR_RECOMMENDED = 'GLT_DATE_CHANGE_ACCEPTED',
    CONFIG_ACCEPTED = 'GLT_CHANGE_CONFIG_ACCEPTED',
    CONFIG_WARNING = 'CHANGE_CONFIG_CONFIRM',
    HAND_WARNING = 'CHANGE_STORNO_CONFIRM',

    DOC_NEW = 'PARMA_DOC_DISP_NEW',
    DOC_FULL = 'PARMA_DOC_PROD_FULL',
    DOC_HALF = 'PARMA_DOC_PROD_HALF',
    DOC_CHANGED = 'PARMA_DOC_PROD_CHANGED',
    DOC_STOP = 'PARMA_DOC_PROD_STOP',
    DOC_RECOMMENDED = 'PARMA_DOC_PROD_FREE',
    DOC_ERROR = 'PARMA_DOC_PROD_ERROR',
    DOC_EDITED = 'PARMA_DOC_PROD_EDITED',
    DOC_ACCEPTED = 'PARMA_DOC_PROD_ACCEPTED',

    USER_IA = 'UBB_USER_IA',
    USER_IV = 'UBB_USER_IV',
    CIRCLE_WARNING = 'UBB_UBBSTATE_CHANGED',
    WRENCH = 'ANMELDETYP_ABH',

    //AIDA
    AIDA_INQUIRY = 'AIDA_INQUIRY',
    AIDA_INQUIRY_IN_PROGRESS = 'AIDA_INQUIRY_IN_PROGRESS',
    AIDA_INQUIRY_WARNING = 'AIDA_INQUIRY_WARNING',
    AIDA_INQUIRY_DONE = 'AIDA_INQUIRY_DONE',
    AIDA_INQUIRY_STOP = 'AIDA_INQUIRY_STOP',
    AIDA_INQUIRY_STORNO = 'AIDA_INQUIRY_STORNO',

    AIDA_OFFER = 'AIDA_OFFER',
    AIDA_OFFER_IN_PROGRESS = 'AIDA_OFFER_IN_PROGRESS',
    AIDA_OFFER_WARNING = 'AIDA_OFFER_WARNING',
    AIDA_OFFER_DONE = 'AIDA_OFFER_DONE',
    AIDA_OFFER_STOP = 'AIDA_OFFER_STOP',
    AIDA_OFFER_STORNO = 'AIDA_OFFER_STORNO',
    AIDA_OFFER_IGNORED = 'AIDA_OFFER_IGNORED',

    AIDA_ORDER = 'AIDA_ORDER',
    AIDA_ORDER_IN_PROGRESS = 'AIDA_ORDER_IN_PROGRESS',
    AIDA_ORDER_WARNING = 'AIDA_ORDER_WARNING',
    AIDA_ORDER_DONE = 'AIDA_ORDER_DONE',
    AIDA_ORDER_STOP = 'AIDA_ORDER_STOP',
    AIDA_ORDER_STORNO = 'AIDA_ORDER_STORNO',

    AIDA_PRODUCTION = 'AIDA_PRODUCTION',
    AIDA_PRODUCTION_IN_PROGRESS = 'AIDA_PRODUCTION_IN_PROGRESS',
    AIDA_PRODUCTION_WARNING = 'AIDA_PRODUCTION_WARNING',
    AIDA_PRODUCTION_DONE = 'AIDA_PRODUCTION_DONE',
    AIDA_PRODUCTION_STOP = 'AIDA_PRODUCTION_STOP',
    AIDA_PRODUCTION_STORNO = 'AIDA_PRODUCTION_STORNO',

    AIDA_KONSI = 'AIDA_KONSI',
    AIDA_KONSI_IN_PROGRESS = 'AIDA_KONSI_IN_PROGRESS',
    AIDA_KONSI_WARNING = 'AIDA_KONSI_WARNING',
    AIDA_KONSI_DONE = 'AIDA_KONSI_DONE',
    AIDA_KONSI_STOP = 'AIDA_KONSI_STOP',
    AIDA_KONSI_STORNO = 'AIDA_KONSI_STORNO',

    AIDA_FACTURA = 'AIDA_FACTURA',
    AIDA_FACTURA_IN_PROGRESS = 'AIDA_FACTURA_IN_PROGRESS',
    AIDA_FACTURA_WARNING = 'AIDA_FACTURA_WARNING',
    AIDA_FACTURA_DONE = 'AIDA_FACTURA_DONE',
    AIDA_FACTURA_STOP = 'AIDA_FACTURA_STOP',
    AIDA_FACTURA_STORNO = 'AIDA_FACTURA_STORNO',

     // NOT ADDED IN PHP
    HOME = 'wb-icon-128__home--default',
    DASHBOARD = 'wb-icon-418__view-gallery-3--default',
    SAFE = 'wb-icon-596__trophy-safety--default',
    UNSAFE = 'wb-icon-594__safety-events--default',
    BROCHURES = 'wb-icon-63__brochures--default',
    ARROW_LEFT = 'wb-icon-5__arrow--default',
    MENU = 'wb-icon-180__menu--default',
    ERROR = 'wb-icon-212__error--default',
    LANGUAGE = 'wb-icon-132__language--default',
    USER = 'wb-icon-142__user--default',
    CONTACT = 'wb-icon-110__contact--default',
    LOGOUT = 'wb-icon-172__logout--default',
    INFO = 'wb-icon-398__information--default',
    LOCATION = 'wb-icon-138__location--default',
    CAR_CONFIG = 'wb-icon-27__car-config--default',
    CAR_LIGHT = 'wb-icon-390__light--default',
    DEALER = 'wb-icon-51__dealer--default',
    ZOOM_OUT = 'wb-icon-426__zoom-out-2--default',
    JOBS = 'wb-icon-519__jobs--default',

    ARROW_LEFT_BG = 'wb-icon-7__arrow--default',
    ARROW_RIGHT_BG = 'wb-icon-6__arrow--default',
    ARROW_DOWN_BG = 'wb-icon-16__arrow-down--default',
}